import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment-timezone";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Pagination from "../layout/Pagination";
import PermissionGate from "../layout/PermissionGate";
import MerchantLogo from "../layout/MerchantLogo";

const MerchantArchive = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [merchant, setMerchant] = useState({});
  const [popup, setPopup] = useState("");
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;
  const fetchMerchants = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}merchant-archive?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const openPopup = (action, data) => {
    setMerchant(data);
    setPopup(action);
  };
  const restoreMerchant = () => {
    if (merchant.id !== undefined) {
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}restore-merchant`,
          {
            id: merchant.id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setMerchant({});
            fetchMerchants();
          }
        })
        .catch(console.error);
    }
  };
  useEffect(() => {
    fetchMerchants();
  }, [page, search]);
  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Merchants Archive
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`view_merchant_archive_list`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="card-header border-0 pt-6">
                      {/*begin::Search*/}
                      <div className="w-100 my-1">
                        <input
                          value={search}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          type="text"
                          data-kt-user-table-filter="search"
                          className="form-control w-100"
                          placeholder="Search Merchant"
                        />
                      </div>
                      {/*end::Search*/}
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div className="card-body py-4 text-center">
                      {/*begin::Table*/}

                      {data?.length === 0 ? (
                        <div className="text-center w-100">
                          <img
                            className="w-25 mx-auto py-20"
                            src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                            alt="no-content"
                          />
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                <th className="text-center min-w-100px">
                                  Merchant Logo
                                </th>
                                <th className="text-center min-w-100px">
                                  Merchant Name
                                </th>
                                <th className="text-center min-w-100px">
                                  Type
                                </th>
                                <th className="text-center min-w-100px">
                                  Currency
                                </th>
                                <th className="text-center min-w-100px">
                                  Pricing Model
                                </th>
                                <th className="text-center min-w-100px">
                                  Memeber Since
                                </th>
                                <th className="text-center min-w-100px">
                                  Status
                                </th>
                                <th className="text-center min-w-100px">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              className="text-gray-600 fw-semibold"
                              id="filterDataWrap"
                            >
                              {data &&
                                data.map((merchant, index) => {
                                  return (
                                    <tr key={index} className="text-center">
                                      <td>
                                        {/*begin:: Avatar */}
                                        <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                          <Link
                                            to={`/merchants/merchant-details/${merchant._id}`}
                                          >
                                            <div className="symbol-label">
                                              <MerchantLogo
                                                merchantLogo={merchant.merchantLogo}
                                                merchantName={merchant.merchantName}
                                                className="w-100"
                                              />
                                            </div>
                                          </Link>
                                        </div>
                                        {/*end::Avatar*/}
                                      </td>
                                      <td>
                                        {/*begin::User details*/}
                                        <div className="d-flex">
                                          <Link
                                            to={`/merchants/merchant-details/${merchant._id}`}
                                            className="text-gray-800 text-hover-primary"
                                          >
                                            {merchant.merchantName}
                                          </Link>
                                        </div>
                                        {/*begin::User details*/}
                                      </td>
                                      <td>{merchant.merchantType}</td>
                                      <td>
                                        <div className="badge bg-warning text-white badge-light fw-bold">
                                          {merchant.currency}
                                        </div>
                                      </td>
                                      <td>{merchant.pricingModel}</td>
                                      <td>
                                        {moment(merchant.createdAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </td>
                                      <td>
                                        <span
                                          className={
                                            merchant.status === true
                                              ? "badge text-white bg-success"
                                              : "badge text-white bg-warning"
                                          }
                                        >
                                          {merchant.status === true
                                            ? "Active"
                                            : "Suspended"}
                                        </span>
                                      </td>
                                      <td className="">
                                        <div className="btn-group">
                                          {/*begin::Restore*/}
                                          <PermissionGate
                                            required={`restore_archived_merchant`}
                                            fallback={<></>}
                                          >
                                            <span
                                              onClick={() => {
                                                openPopup("restore", {
                                                  id: merchant._id,
                                                });
                                              }}
                                              className="btn ps-2 pe-1 btn-outline btn-success btn-color-white btn-sm"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Restore Employee"
                                            >
                                              <i className="bi-duotone bi-arrow-counterclockwise mx-auto fs-3"></i>
                                            </span>
                                          </PermissionGate>
                                          {/*end::Restore*/}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {/*end::Table*/}
                      {/*begin::Paginate*/}
                      {count && Math.ceil(count / limit) > 1 ? (
                        <Pagination
                          page={page}
                          setPage={setPage}
                          count={count}
                          limit={limit}
                        />
                      ) : (
                        ""
                      )}
                      {/*end::Paginate*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/* start ::restore */}
          <div
            className={
              popup === "restore" ? "modal fade show d-block" : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-success text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">RESTORE</h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setMerchant({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={restoreMerchant}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: restore */}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default MerchantArchive;
